import { environment } from '@environments/environment';

export function imagenPathS3(path) {
  return (target: any, propertyKey: string) => {
    const getter = function (this: any) {
      if (this['_' + propertyKey]) {
        return environment.apiImageStatic + path + '/' + this['_' + propertyKey];
      }
      return undefined;
    };
    const setter = function (this: any, next: any) {
      this['_' + propertyKey] = next;
    };
    Object.defineProperty(target, propertyKey, {
      get: getter,
      set: setter,
    });
  };
}
